import React from 'react'
import DateBox from './date-box'
import SearchBox from './search-box'
import HourBox from './hour-box'


const ExperienceParam = ({
    label,
    value,
    onChange = () => {}
}) => {
    const [filters, setFilters] = React.useState({})
    return (
        <div>
            <DateBox
                label='Search Start Date'
                placeholder='Select start date'
                value={filters.startDate}
                onChange={startDate => setFilters({ ...filters, startDate})}
                
            />
            <DateBox
                label='Search End Date'
                placeholder='Select end date'
                value={filters.endDate}
                onChange={endDate => setFilters({ ...filters, endDate})}
                
            />
            <HourBox 
                label='Search Hours'
                placeholder='Select hour'
                value={filters.hour}
                onChange={hour => setFilters({ ...filters, hour})}
            />
            <SearchBox
                label={label}
                value={value}
                onChange={onChange}
                startDate={filters.startDate}
                endDate={filters.endDate}
                hour={filters.hour}
            />
        </div>
    )
}

export default ExperienceParam